import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { EBoksRecipientType, } from '@debbie/common/dist/interactions';
import { selectTemplatesMap } from '@debbie/cortex/dist/templates/selectors';
import { Modal, Badge } from '..';
import { APIBASE } from '../../config';
import THEME from '../../theme';
import { FileText } from '../Icons';
import DefaultSummary from './DefaultSummary';
import ObjectComp from '../ObjectComp';
const EBoksSummary = (props) => {
    var _a;
    const [openPDF, setOpenPDF] = useState(false);
    const [openMetadata, setOpenMetadata] = useState(false);
    const [interactionEvent, setInteractionEvent] = useState(null);
    const eboks = props.interaction.details;
    const lang = useSelector((s) => s.lang);
    const template = useSelector((s) => {
        const templatesMap = selectTemplatesMap(s);
        return ((props.interaction.templateId &&
            templatesMap[props.interaction.templateId]) ||
            null);
    });
    return (React.createElement(DefaultSummary, Object.assign({ transparrent: !openPDF }, props),
        React.createElement("div", { style: {
                cursor: 'pointer',
            }, onClick: () => {
                setOpenPDF(!openPDF);
            } },
            template && (React.createElement(React.Fragment, null,
                React.createElement("p", { style: {
                        fontWeight: '900',
                        margin: '0 0 0.8em',
                    } }, template.name),
                !!((_a = template.tags) === null || _a === void 0 ? void 0 : _a.length) && (React.createElement("p", { style: { marginTop: 0 } }, template.tags.map(({ tag }) => (React.createElement(Badge, { style: { marginRight: 5 }, theme: THEME.COLOR_ACCENT }, lang.templateTags[tag]))))))),
            React.createElement("p", { style: {
                    marginTop: '0px',
                } }, eboks.recipient.type === EBoksRecipientType.CentralRegisterId ? (React.createElement(HighlightedRecipient, null,
                eboks.recipient.isCompany ? 'CVR' : 'CPR',
                ":",
                ' ',
                eboks.recipient.centralRegisterId)) : eboks.recipient.type === EBoksRecipientType.KVHX ? (React.createElement(React.Fragment, null,
                React.createElement(HighlightedRecipient, null, eboks.recipient.firstName),
                ' ',
                React.createElement(HighlightedRecipient, null, eboks.recipient.lastName),
                ' ',
                React.createElement(HighlightedRecipient, null, eboks.recipient.kvhx))) : null),
            React.createElement("p", { style: {
                    marginTop: '0px',
                } },
                React.createElement(FileText, { style: {
                        margin: '0.15em 0 -0.15em 0',
                    } }),
                ' ',
                eboks.title),
            props.interaction.transacted
                ? `${lang.interactions.transacted} ${moment(props.interaction.transacted).format(THEME.DATE_FORMAT_LONG)}`
                : '',
            props.interaction.events && !!props.interaction.events.length ? (React.createElement("div", { style: {
                    marginTop: `${THEME.GRID_SPACING}px`,
                    wordBreak: 'break-word',
                } }, props.interaction.events.map((event) => (React.createElement("div", { "data-tooltip-id": "tooltip-default", key: event.id, style: { display: 'inline-flex', width: 'fit-content' }, "data-tooltip-content": moment(event.createdAt).format(THEME.DATE_FORMAT_LONG), onClick: (e) => {
                    setInteractionEvent(event);
                    setOpenMetadata(true);
                    e.stopPropagation();
                } },
                React.createElement(Badge, { theme: event.type === 'delivered'
                        ? THEME.SUCCESS
                        : event.type === 'failed'
                            ? THEME.DANGEROUS
                            : THEME.WARNING, style: { marginRight: '5px' } }, 
                // @ts-ignore
                lang.interactions[event.type] || event.type)))))) : null),
        openPDF && (React.createElement(Modal, { header: lang.interactionTypes.EBOKS, onToggle: () => {
                setOpenPDF(!openPDF);
            } },
            React.createElement(ObjectComp, { type: "application/pdf", url: `${APIBASE}/files/${eboks.pdf}/debbie.pdf` }))),
        openMetadata && (React.createElement(Modal, { header: lang.interactions.metadata, onToggle: () => {
                setOpenMetadata(false);
                setInteractionEvent(null);
            } }, interactionEvent && interactionEvent.data && (React.createElement(EventMetadataTable, null,
            React.createElement("tr", null,
                React.createElement("td", null, "type"),
                React.createElement("td", null, interactionEvent.type)),
            React.createElement("tr", null,
                React.createElement("td", null, "createdAt"),
                React.createElement("td", null, moment(interactionEvent.createdAt).format(THEME.DATE_FORMAT_LONG))),
            Object.entries(interactionEvent.data).map(([k, v]) => (React.createElement("tr", null,
                React.createElement("td", null, k),
                React.createElement("td", null, v))))))))));
};
export default EBoksSummary;
const HighlightedRecipient = styled.span `
  background-color: #f4f4f4;
  border-radius: 5px;
  padding: 4px 6px;
  font-size: 0.7em;
`;
const EventMetadataTable = styled.table `
  padding: 4px;
  background-color: #f4f4f4;
  border-radius: 5px;
  width: 100%;

  td {
    font-family: 'Courier New', monospace;
  }

  td:first-child {
    font-weight: bold;
  }
`;
//# sourceMappingURL=EBoksSummary.js.map